import {
  getData,
  postData,
} from './Services'

export const getInventariosCabPanel = async (searchIDSel, searchIDDepo, searchID, dateFrom,dateUntil, page, perPage) => {
  let queryParams = [];
  if (searchIDSel) {
    queryParams.push(`aju_sel_id=${encodeURIComponent(searchIDSel)}`);
  }
  if (searchIDDepo) {
    queryParams.push(`aju_depo_id=${encodeURIComponent(searchIDDepo)}`);
  }
  if (searchID) {
    queryParams.push(`aju_id=${encodeURIComponent(searchID)}`);
  }
  if (dateFrom) {
    queryParams.push(`fechaDesde=${encodeURIComponent(dateFrom)}`);
  }
  if (dateUntil) {
    queryParams.push(`fechaHasta=${encodeURIComponent(dateUntil)}`);
  }

  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/artAjustescab/ArtAjusteCabFiltros", queryString);
}


export const getInventarioCabById = async (id) => {
  const res = await getData(`/artAjustesCab/${id}`)
  return res
}

export const postInventarioCab = async (body) => {
  const res = await postData('/artAjustesCab', body)
  return res
}
